import React from "react";
import { IconButton } from "@mui/material";

interface CustomIconButtonProps {
    onClick: () => void;
    icon: React.ReactNode;
    sx?: object;
}

const CustomIconButton: React.FC<CustomIconButtonProps> = ({
    onClick,
    icon,
    sx,
}) => {
    return (
        <IconButton onClick={onClick} sx={{ color: "black", ...sx }}>
            {icon}
        </IconButton>
    );
};

export default CustomIconButton;
